export default __webpack_public_path__ + "static/media/new-message-icon.3426ff48.svg";